import React from 'react';
import { Box } from '@mui/material';

import { useMytaverseEvent } from '@core/dashboard/providers';
import EmojiItem from './EmojiItem';
import { EMOJI_LIST } from './constants';
import { useStyles } from './styles';

const Emojis = () => {
  const classes = useStyles();
  const { setEmoji } = useMytaverseEvent();

  return (
    <Box sx={classes.root}>
      {EMOJI_LIST.map((emoji) => (
        <EmojiItem
          key={emoji.id}
          src={emoji.img}
          onClick={() => setEmoji(emoji.id)}
        />
      ))}
    </Box>
  );
};

export default Emojis;
